<div class="modal__header">
  <span class="title">Идет распределение</span>
</div>

<div class="modal__body">
  <div class="automatic-progress">
    <div class="automatic-progress__countdown" *ngIf="remainingSeconds > 0; else distributionDelay">
      Осталось: {{ remainingSeconds }} сек.
    </div>
    <ng-template #distributionDelay>
      <div class="automatic-progress__countdown">Ожидаем завершения распределения. Это может занять несколько минут.</div>
    </ng-template>
    <div class="automatic-progress__spinner">
      <app-loader [position]="'reset'"></app-loader>
    </div>
  </div>
</div>
